import { useEffect, useState } from 'react'
import jwtDecode from 'jwt-decode'
import { Typography, Box } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { SelectObj } from 'components'
import { getRelations } from 'services'
import { useNotification, useQuery } from 'hooks'

interface RelationStepProps {
  type: 'informant' | 'caregiver'
}

function RelationStep({ type }: RelationStepProps): JSX.Element {
  const [options, setOptions] = useState([])

  const { control, watch } = useFormContext()
  const { errorToast } = useNotification()
  const query = useQuery()

  const getPatientName = () => {
    if (type === 'informant') {
      const invitationToken = query.get('invitationToken')
      const userInfos: any = jwtDecode(invitationToken!)
      return userInfos?.createdBy?.name.split(' ')[0] || 'o paciente'
    } else if (type === 'caregiver') {
      const patientFirstName = watch('firstName')
      return patientFirstName || 'o paciente'
    }

    return 'o paciente'
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const relations = await getRelations()

        const sortedRelations = relations.sort((a: any, b: any) => {
          if (a.name === 'Sou eu') return -1
          if (b.name === 'Sou eu') return 1
          return 0
        })

        setOptions(
          sortedRelations?.map(({ id, name }: any) => ({
            value: id,
            label: name,
          })) || []
        )
      } catch (error: any) {
        console.error(error)
        errorToast(error?.message || 'Erro desconhecido')
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Typography variant='title'>
        Qual a sua <b>relação</b> com {getPatientName()}?
      </Typography>
      <Box mt={5}>
        <SelectObj name='relation' control={control} options={options} />
      </Box>
    </>
  )
}

export default RelationStep
